import React from "react";
import { Navigate, Outlet } from "react-router-dom";

export const MenteePrivateRoute = () => {
  // If authorized, return an outlet that will render child elements
  // If not, return element that will navigate to login page
  if(localStorage.getItem("role")) {
    if(localStorage.getItem("role") === "a590950b-ec5a-4316-aa93-0bcc7cfc69da") return <Outlet />
    }
    localStorage.clear();
    return <Navigate to="/login" />
};